import { createElement as e } from "react";
import ReactDOM from "react-dom";

import UrlTree from "./components/url_tree";

(() => {
    "use strict";
    const parsedStatePbuMap = cedar.safelyParseJSONFromString($("#_state-pbu-map").text());
    const parsedStatesList = cedar.safelyParseJSONFromString($("#_states-list").text());

    const urlTreeProps = {
        statePbuMap: parsedStatePbuMap,
        statesList: parsedStatesList,
    };
    const urlTreeDomContainer = document.querySelector("#react_url_dom_tree");
    ReactDOM.render(e(UrlTree, urlTreeProps), urlTreeDomContainer);
})();
